import React from "react";
import { useNavigate } from "react-router-dom";
import {
  MOB_DEVICE_SIGNAL_STORAGE_NAME,
  RENDERER_UNIT_PAGE,
} from "../../Constants";
import ViewSelectionButton from "./styling/ViewSelectionButton";

export default function ViewerOptions({ sessionInfoUI, stream }) {
  const navigate = useNavigate();

  const MOB_STORE_INFO = JSON.parse(
    localStorage.getItem(MOB_DEVICE_SIGNAL_STORAGE_NAME),
  );

  const handleNavigationToRenderer = (background) => {
    navigate(RENDERER_UNIT_PAGE, {
      state: {
        redirect: true,
        background: background,
        streamThreading: MOB_STORE_INFO.streamThreading,
      },
    });
  };
  return (
    <div className="paddingtop20">
      {stream && MOB_STORE_INFO && (
        <>
          <h1>Please select viewer</h1>
          <ViewSelectionButton
            enabled={true}
            Title="Plain"
            selectionHandler={handleNavigationToRenderer}
            backgroundSource="/none"
            imageSource="/plain.jpg"
          />

          {!MOB_STORE_INFO.backgroundsEnabled && (
            <h2 className="font-weight-normal">
              ~~~~~ Locked{" "}
              <span>
                <i class="fa-left-padding fa-solid fa-lock"></i>
              </span>{" "}
              ~~~~~
            </h2>
          )}
          <ViewSelectionButton
            enabled={MOB_STORE_INFO.backgroundsEnabled}
            Title="Dusk"
            selectionHandler={handleNavigationToRenderer}
            backgroundSource="/dusk_4k.hdr"
            imageSource="/dusk.jpg"
          />
          <ViewSelectionButton
            enabled={MOB_STORE_INFO.backgroundsEnabled}
            Title="Golden Hour"
            selectionHandler={handleNavigationToRenderer}
            backgroundSource="/golden_hour_4k.hdr"
            imageSource="/goldenhour.jpg"
          />
          <ViewSelectionButton
            enabled={MOB_STORE_INFO.backgroundsEnabled}
            Title="Milkyway"
            selectionHandler={handleNavigationToRenderer}
            backgroundSource="/milkyway_night_4k.hdr"
            imageSource="/milkyway.jpg"
          />
          {!MOB_STORE_INFO.backgroundsEnabled && (
            <>
              <h2 className="paddingtop20 font-weight-normal">
                ~~~~~~~~~~~~~~~~~~~
              </h2>
              <h2 className="paddingtop20 font-weight-normal">
                Upgrade To Unlock
              </h2>
              <h2 className="paddingtop20 font-weight-normal">
                ~~~~~~~~~~~~~~~~~~~
              </h2>
            </>
          )}
        </>
      )}
    </div>
  );
}
